/*
 * Public API Surface of ngx-verify-code
 */

export * from './lib/ngx-verify-code.component';
export * from './lib/ngx-verify-code.module';
